import { Get, Set } from "../../../../Request";

export const AdminAttemptToLogin = async (username, password) => {
  return await Get({
    url: "/loginnadminn",
    data: {
      username,
      password,
    },
  }).then(data => {
    return data;
  });
};

export const CheckUser = async mobile => {
  return await Get({
    url: "/checkmobile",
    data: {
      mobile,
      app: true
    },
  }).then(data => {
    return data;
  });
};

export const ForgetPass = async mobile => {
  return await Get({
    url: "/forgetpassword",
    data: {
      mobile,
    },
    stat: true
  }).then(data => {
    return data;
  });
};

export const UserAttemptToLogin = async (mobile, password) => {
  return await Get({
    url: "/login",
    data: {
      mobile,
      password,
    },
  }).then(data => {
    return data;
  });
};

export const VerifyCode = async (mobile, verifycode, sans_reserve) => {
  return await Get({
    url: "/validationcode",
    data: {
      mobile,
      verifycode,
      sans_reserve,
    },
  }).then(data => {
    return data;
  });
};
export const verifyCodeNewPassword = async (
  mobile,
  newpassword,
  verifycode
) => {
  return await Get({
    url: "/validationcode",
    data: {
      mobile,
      verifycode,
      newpassword,
    },
  }).then(data => {
    return data;
  });
};
export const ResendVerifyCode = async mobile => {
  return await Set({
    url: "/resend_code",

    data: {
      mobile,
    },
  }).then(data => {
    return data;
  });
};

export const SignupSubmit = async (
  fullname,
  mobile,
  identifiercode,
  password
) => {
  return await Get({
    url: "/signup",
    data: { fullname, mobile, identifiercode, password },
  }).then(data => {
    return data;
  });
};

export const GetSeo = async slug => {
  return await Get({
    url: "/signs/get_seo",
    data: {},
  }).then(data => {
    return data;
  });
};
